<template>
    <div>
        <div class="form-actions">
            <b-button variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
            <b-button variant="danger" @click="remove" v-if="relation.foreign != ''" class="ml-2">{{ $t('remove')
                }}</b-button>
        </div>

        <b-modal title="Edit relationships" v-model="editor.show" @ok="save" @cancel="remove">
            <b-form-group :description="this.$t('relatedFields')" :label="this.$t('component')" label-for="component"
                :label-cols="3" :horizontal="false">
                <b-form-select id="module" :plain="false" :options="componentList" v-model="relation.foreign">
                </b-form-select>
            </b-form-group>
            <b-form-group :label="this.$t('primaryKey')" label-for="keys" :label-cols="3" :horizontal="false">
                <b-form-select id="keys" :plain="false" :options="fieldLists" v-model="relation.key[0]">
                </b-form-select>
            </b-form-group>
            <b-form-group :label="this.$t('foreignKey')" label-for="keys" :label-cols="3"
                :description="this.$t('foreignKeyCanOnlyBeUnique')" :horizontal="false">
                <b-form-select id="foreignKeys" :plain="false" :options="foreignKeys" v-model="relation.key[1]">
                </b-form-select>
            </b-form-group>
            <b-form-group :label="this.$t('type')" label-for="type" :label-cols="3" :horizontal="false">
                <b-form-select id="type" :plain="false" :options="['one-to-one', 'one-to-many']" v-model="relation.type">
                </b-form-select>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        scope: {
            type: String
        },

        fields: {
            type: Array
        },

        value: {
            type: Object
        },
        
        field: {
            type: Object
        }
    },
    watch: {
        "relation.foreign": function () {
            this.$store.dispatch("fetchComponentsSettings", this.relation.foreign).then(settings => {
                let fields = _.cloneDeep(settings.settings.fields);

                fields.unshift({
                    key: "uuid",
                    module: "input",
                    type: "text"
                })

                fields.map(el => {
                    el.text = el.key
                    el.value = el.key
                })

                // TODO: update this back to proper value
                this.relation.foreign_uuid = settings.general.uuid

                this.foreignKeys = fields.filter(f => {
                    return (f.module == 'input' && (f.type == 'text' || f.type == 'number')) || f.module == 'select' && (f.type == 'relation');
                })
            });
        }
    },
    methods: {
        save(modal) {
            if (this.relation.foreign == "" || this.relation.key.length < 2) {
                this.$bvToast.toast(this.$t('settingsRelationship'), {
                    variant: 'warning',
                    title: "Warning"
                })

                modal.preventDefault()

                return false
            }

            this.$emit('input', this.relation)
        },

        remove() {
            this.relation.foreign = ""
            this.relation.foreign_uuid = null
            this.relation.key = []
            this.relation.type = ""

            this.$emit('input', this.relation)
        }
    },
    data: function () {
        return {
            editor: {
                show: false,
            },

            foreignKeys: [],
            relation: null,
        }
    },
    computed: {
        componentList() {
            let cm = this.$store.getters.componentsMenu

            cm.map(el => {
                let value = el.name
                if (el.scope) {
                    value = `${el.scope}::${el.name}`
                }

                el.text = this.$translateLabel(el.label, el.name)
                el.value = value

                return el
            })

            let filtered = cm.filter(el => {
                return el.is_active
            }).filter(el => {
                return el.scope == this.scope
            })

            if (filtered.length < 1) {
                return [
                    {
                        text: this.$t('noActiveComponent'),
                        value: null
                    }
                ]
            }

            return filtered
        },

        fieldLists() {
            let fields = this.fields.slice()
            // every model has uuid by default
            fields.unshift({
                key: "uuid",
                module: "input",
                type: "text"
            })

            let found = fields.find(f => {
                return f.key == this.field.key
            })

            if (found === undefined) {
                fields.push(this.field)
            }

            fields.map(el => {
                el.text = el.key
                el.value = el.key
            })


            return fields
        }
    },

    mounted() {
        this.relation = this.value

        if (this.relation !== undefined) {
            this.$store.dispatch("fetchComponentsSettings", this.relation.foreign).then(settings => {
                let fields = _.cloneDeep(settings.settings.fields);

                fields.unshift({
                    key: "uuid",
                    module: "input",
                    type: "text",
                    constraints: {
                        unique: true
                    }
                })

                fields.map(el => {
                    el.text = el.key
                    el.value = el.key
                })

                this.foreignKeys = fields.filter(f => {
                    return (f.module == 'input' && (f.type == 'text' || f.type == 'number')) || f.module == 'select' && (f.type == 'relation');
                }).filter(f => {
                    return f.constraints.unique
                })
            });
        }
    }
}
</script>
